export default __webpack_public_path__ + "static/media/multilingual.c9d9d5bd.svg";